export default "__VITE_ASSET__ca08df68__"